import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button,
    Divider,
    TextField,
    InputAdornment,
    IconButton,
    CircularProgress,
    Typography,
    Link
} from "@material-ui/core";

import LinkedInIcon from '@material-ui/icons/LinkedIn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';

import Alert from '@material-ui/lab/Alert';

import FloatingContainer from "src/shared_modules/veu-visitors-core/components/common/container/floatingContainer";
import ScrollContainer from "src/shared_modules/veu-visitors-core/components/common/container/scrollContainer";

import {
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    login
} from 'src/shared_modules/veu-visitors-core/actions/user';

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

import './user.css';


class PopoverLogin extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error: "",
            canSend: false,
            isBusy: false,
            failed: false,
            fields: {
                username: "",
                password: ""
            },
            showPassword: false,
        }
    }

    componentDidMount() {

    }

    clickCancel() {
        // TODO send cancel to Plazz API if isBusy = true

        this.setState({
            isBusy: false,
            fields: { username: "", password: "" },
            canSend: false,
            showPassword: false,
            error: "",
            failed: false,
        });
        this.props.hidePopover("Login");
    }

    clickForgot() {
        // TODO send cancel to Plazz API if isBusy = true

        this.setState({
            isBusy: false,
            fields: { username: "", password: "" },
            canSend: false,
            showPassword: false,
            error: "",
            failed: false,
        });
        this.props.hidePopover("Login");
        this.props.showPopover("Forgot");
    }

    clickCreate() {
        // TODO send cancel to Plazz API if isBusy = true

        this.setState({
            isBusy: false,
            fields: { username: "", password: "" },
            canSend: false,
            showPassword: false,
            error: "",
            failed: false,
        });
        this.props.hidePopover("Login");
        this.props.showPopover("Register");

    }

    async clickSend() {
        if (this.state.isBusy || !this.state.canSend)
            return;

        this.setState({
            isBusy: true,
            failed: false,
            error: "",
            showPassword: false,
        });

        let error = await this.props.login(
            this.state.fields.username,
            this.state.fields.password,
        );

        if (error !== false) {
            this.setState({
                failed: true,
                isBusy: false,
                error: "popovers.login.failed"
            });

        } else {
            this.setState({
                isBusy: false,
                fields: { username: "", password: "" },
                canSend: false
            });
            this.props.hidePopover("Login");
            this.props.trackEvent("login", "success", "local");

            if( this.props.user.isTmpPwd ) {
                this.props.showPopover("Account");
            } else if( this.props.user.plazz.forcePrivacySetup ) {
                this.props.showPopover("Privacy");
            }
        }
    }

    validateInput(value) {
        // just not empty
        if (value === undefined || value === null || value.trim() === "")
            return false;

        return true;
    }

    handleInputChange(field, event) {
        event.preventDefault();
        // update the field value
        let fields = this.state.fields;
        let val = event.target.value;
        fields[field] = val;

        let canSend = true;

        if (!this.validateInput(fields["username"]))
            canSend = false;

        if (!this.validateInput(fields["password"]))
            canSend = false;

        this.setState({
            fields: fields,
            canSend: canSend,
        });
    }

    togglePasswordVisibility() {
        this.setState({ showPassword: !this.state.showPassword });
    }

    renderDivider() {
        /* works with material UI 5.x.x Q42020 <Divider><Translate>popovers.login.loginWith_text</Translate></Divider> */

        return (<React.Fragment>
            <Divider component="div" className="divider-with-label" />
            <Typography
                className="divider-label"
                component="div"
                variant="caption"
            >
                <Translate>popovers.login.loginWith_text</Translate>
            </Typography>
        </React.Fragment>);
    }

    renderHint() {
        let showHint = false;
        if (this.props.hint !== null)
            showHint = true;

        let label = "popovers.login.hints." + this.props.hint;

        return (<React.Fragment>
            { showHint && <div className="user-form-hint">
                <Alert variant="filled" icon={<NotificationImportantIcon color="primary" fontSize="large" />}>
                    <Typography color="primary" variant="caption">
                        <Translate> {label}</Translate>
                    </Typography>
                </Alert>
            </div>}
        </React.Fragment>);
    }

    render() {

        if (!this.props.showLogin)
            return (null);

        let urlLogin = this.props.meaconfig.baseUrl + "/authenticate/request/";
        let urlSchaeffler = urlLogin + "1/customer?targetUrl="
            + window.location.origin + "/visitor/" + this.props.eventpath
            + "/auth/schaeffler&errorUrl=" + window.location.origin + "/visitor/"
            + this.props.eventpath + "/auth/failed";
        let urlLinkedin = urlLogin + "2/customer?targetUrl="
            + window.location.origin + "/visitor/" + this.props.eventpath
            + "/auth/linkedin&errorUrl=" + window.location.origin + "/visitor/"
            + this.props.eventpath + "/auth/failed";

        // IMPORTANT :
        // this here is need because of a "bug" in ClickAwayListener
        // which steals the focus of an Textfield during input.
        let focusUsername = false;
        let focusPassword = false;

        if (this.state.focus === "username")
            focusUsername = true;
        if (this.state.focus === "password")
            focusPassword = true;

        //-- new to auto-shanghai; protected but no new users allowed
        // JED 16.04.2021
        var allowRegister = !this.props.event.disableNewUserRegistration;

        return (<FloatingContainer position="center"
            width="sm"
            fsSwitch="xs"
            className="user outer-flex-scroll-container user-login"
            modal
            onClickAway={() => { this.clickCancel(); }}
            largeBottomPadding={this.props.event.hasUserlike}
        >
            <ScrollContainer className="user-login">
                <form onSubmit={(e) => { e.preventDefault(); }} >
                    <Typography variant="h6" component="h1" color="primary" className="user-form">
                        <Translate>popovers.login.title_visitor</Translate>
                    </Typography>
                    {this.renderHint()}
                    <TextField id="username" key="login-username"
                        autoFocus={focusUsername}
                        required
                        fullWidth
                        label={<Translate>person-labels.username</Translate>}
                        variant="outlined"
                        value={this.state.fields["username"]}
                        onChange={(e) => { this.handleInputChange("username", e); }}
                    />
                    <p></p>
                    <TextField id="password" key="login-password"
                        autoFocus={focusPassword}
                        required
                        fullWidth
                        label={<Translate>person-labels.password</Translate>}
                        variant="outlined"
                        autoComplete="current-password"
                        value={this.state.fields["password"]}
                        onChange={(e) => { this.handleInputChange("password", e); }}
                        type={this.state.showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton aria-label="toggle password visibility"
                                        onClick={() => this.togglePasswordVisibility()}
                                        edge="end"
                                    >
                                        {this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                        }}
                    />
                    <p></p>
                    <div className="forgotLoginData">
                        <Link component="button"
                                className="light-grey-text"
                                onClick={() => { this.clickForgot(); }}
                            >
                            <Translate>popovers.login.forgotLoginData</Translate>
                        </Link>
                    </div>
                    {this.state.failed && <div className="user-form-alert"><Alert variant="outlined" severity="error">
                        <Translate>{this.state.error}</Translate>
                    </Alert></div>}

                    <div className="user-form-button-bar">
                        <Button variant="contained"
                            size="large"
                            color="secondary"
                            onClick={() => { this.clickSend(); }}
                            disabled={!this.state.canSend}
                            type="submit"
                            endIcon={this.state.isBusy && <CircularProgress color="inherit" size={20} />}
                        >
                            <Translate>popovers.login.send</Translate>
                        </Button>
                        <Button size="large"
                            color="primary"
                            onClick={() => { this.clickCancel(); }}
                        >
                            <Translate>popovers.login.cancel</Translate>
                        </Button>
                    </div>

                    {allowRegister &&
                        <Button color="secondary"
                            style={{ paddingLeft: "0" }}
                            onClick={() => { this.clickCreate(); }}
                            disabled={this.state.isBusy}
                        >
                            <Translate>popovers.login.register</Translate><br />
                        </Button>
                    }
                    { /* FIXME TEMPRÄRY REMOVED this.renderDivider() }
                            { /* FIXME TEMPRÄRY REMOVED
                                <Button variant="outlined"
                                    className="sso-button"
                                    fullWidth
                                    color="primary"
                                    href={urlLinkedin}
                                >
                                <LinkedInIcon/> LinkedIn
                            </Button> */}
                    <br /><br />
                    <Typography variant="h6" component="h2" className="user-form" color="primary">
                        <Translate>popovers.login.title_tenant</Translate>
                    </Typography>
                    <Button variant="contained"
                        color="secondary"
                        fullWidth
                        size="large"
                        href={urlSchaeffler}
                        disabled={this.state.isBusy}
                    >
                        Schaeffler Single Sign On
                            </Button>

                </form>
            </ScrollContainer>
        </FloatingContainer>);
    }
}

PopoverLogin.propTypes = {
    meaconfig: PropTypes.object,
    eventpath: PropTypes.string,
    showLogin: PropTypes.bool,
    hint: PropTypes.string,
    user: PropTypes.object,
    event: PropTypes.object,

};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = (state, ownProps) => {
    return {
        meaconfig: state.plazz.mea.config,
        eventpath: state.event.path,
        showLogin: state.popovers.showLogin,
        hint: state.popovers.loginHint,
        user: state.user,
        event: state.event,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
    login
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withMatomo(PopoverLogin));
